function catchedErrorHandler(error, errorInfo) {
  const componentStack = errorInfo ? errorInfo.componentStack : '';
  return {
    clientError: error.toString(),
    type: 'ERROR',
    msg: [componentStack]
  };
}
export default catchedErrorHandler;